import { ScreenNames, trackScreenShown } from 'analytics/analytics'
import { useEffect } from 'react'

export const useTrackScreenShown = (screenName?: ScreenNames) => {
  useEffect(() => {
    if (screenName) {
      trackScreenShown(screenName)
    }
  }, [screenName])
}
